
/*
 * @Author: Lim 
 * @Date: 2020-09-07 15:28:45 
 * @Last Modified by: Lim
 * @Last Modified time: 2020-09-11 11:04:45
 */
import React, { useState, useEffect } from 'react';
import style from './Checkbox.module.scss';
import cn from 'classnames'
import { initConfig, unitFilter } from './../common'

export default (props) => {
    /**
     * default
     */
    const defaultConfig = {
        direction : 'row',
        data : [{id:'1',value:'选项一'}],
        iconColor: '#3B99FC',
        fontSize: 12,
        fontColor: '#28334B',
        titleFlag: false,
        margin: '',
        check(){}
    }
    /**
     * initial
     * 数据对比
     * 单位过滤
     */
    const { 
        direction,
        data,
        iconColor,
        fontSize,
        fontColor,
        margin,
        titleFlag,
        check
    } = initConfig( defaultConfig, props.config );

    const defaultFontSize = unitFilter ( fontSize );
    const dataJson = JSON.stringify(data);
    /**
     * state
     * 列表
     */
    const [ newData, setNewData ] = useState( data );
    /**
     * didmount & update & unMount
     * didmount 列表初始化
     * update 回调
     */
    useEffect(() =>{
        setNewData( addTrack( data ) );
    },[ dataJson ])
    useEffect(() =>{
        _afterCheck();
    },[newData])
    /**
     * Func
     * 选项添加轨迹
     * 创建列表结构
     * 点击选择( 正向递归 & 反向递归 )
     * 选择后回调( propType: Array )
     */
    const addTrack = ( obj, index ) =>{
        obj.forEach(( item, key )=>{
            if( item.checked !== true )  item.checked = false;
            if( index === undefined ){
                item.track = key
            }else{
                item.track = index +'_'+ key
            }
            if (item.children) {
                addTrack( item.children, item.track );
            }
        })
        return obj;
    }
    
    const _createList = () => {
        const getList = (data) =>{
            return data.map((item,key)=>{
                if (item.children) {  
                    return (
                        <div key = { key } className={ cn( style.check_box_group ) }>
                            <div 
                                className={cn(
                                    style.check_box, 
                                    item.disable ? style.disable : ""
                                )}
                                style = {{ fontSize: defaultFontSize, margin }}
                                onClick={ ()=>{ _check( item.id ) } }
                            >
                                <span 
                                    className = { cn(
                                        style.icon, 
                                        "font_family",
                                        item.checked ? "icon-checkboxSeleted" : "icon-checkboxDefault"
                                    )}
                                    style = {{ color : item.checked ? iconColor : ""}}
                                ></span>
                                <label 
                                    className={ style.value }
                                    style = {{ color : fontColor, cursor : "pointer" }}
                                    title = { titleFlag ? item.value : "" }
                                >{ item.value }</label>
                            </div>
                            <div
                                className={ style.children_group }
                                style={ direction === "row" ? { flexDirection: "row"} : { flexDirection: "column" } }
                            >
                                { getList( item.children ) }
                            </div>
                        </div>
                    )
                }else{
                    return (
                        <div 
                            key = { key }
                            className={ cn(
                                style.check_box,
                                style.check_box_inline_block,
                                item.first === true ? style.firstCheck : ""
                            ) }
                            style = {{ fontSize, margin }}
                        >
                            <div>
                                <div 
                                    className={cn(
                                        style.check_box, 
                                        item.disable ? style.disable : ""
                                    )}
                                    onClick={ ()=>{ _check( item.id ) } }
                                >
                                    <span 
                                        className = { cn(
                                            style.icon, 
                                            "font_family",
                                            item.checked ? "icon-checkboxSeleted" : "icon-checkboxDefault"
                                        )}
                                        style = {{ color : item.checked ? iconColor : "" }}
                                    ></span>
                                    <span 
                                        className={ style.value }
                                        title = { titleFlag ? item.value : "" }
                                        style = {{ color : fontColor , cursor : "pointer" }}
                                    >{ item.value }</span>
                                </div>
                            </div>
                        </div>
                    );
                }
            })
        }
        return getList( newData );
    }
    const _check = ( checkId ) => {
        let checkObj = {};
        let newObj = JSON.parse(JSON.stringify( newData ));
        const addTrack = ( obj ) =>{
            obj.forEach(( item )=>{
                if( item.id === checkId ){
                    checkObj = item;
                }
                if (item.children) {
                    addTrack( item.children, item.track );
                }
            })
            return checkObj;
        }
        let obj = addTrack( newObj );
        if( obj.disable === true ) return false;
        obj.checked = !obj.checked;
        // 正向递归
        if( obj.children ){
            const childrenList = ( item,checked ) =>{
                item.checked = checked;
                item.forEach((obj)=>{
                    if(obj.disable !== true){
                        obj.checked = item.checked
                    }
                    if (obj.children) {
                        childrenList ( obj.children, obj.checked );
                    }
                })
            }
            childrenList( obj.children, obj.checked )
        }

        // 反向递归
        const parentList = (obj) =>{
            const trackArr = String( obj.track ).split('_');
            if( trackArr.length > 1 ){
                // 定义该对象父级
                let parentObj = {};
                if( trackArr.length == 2 ){
                    parentObj = newObj[trackArr[0]];
                }else{
                    parentObj = newObj[trackArr[0]].children;
                    for(var i = 1 ; i < trackArr.length-1; i++){
                        if(i === trackArr.length-2){
                            parentObj = parentObj[trackArr[i]]
                        }else{
                            parentObj = parentObj[trackArr[i]].children
                        }
                    }
                }
                parentObj.checked = true;
                parentObj.children.forEach((item)=>{
                    if(item.checked !== true){
                        if(obj.disable !== true){
                            parentObj.checked = false;
                        }
                    }
                })
                parentList(parentObj)
            }
        }
        parentList( obj );
        setNewData( newObj )
    }

    const _afterCheck = () => {
        let checkedArr = [];
        const getList = (data) =>{
            data.forEach((item)=>{
                if( item.checked ){
                    checkedArr.push({ id: item.id, value: item.value })
                }
                if (item.children) {
                    getList( item.children );
                }
            })
        }
        getList( newData );
        check ( checkedArr ) 
    }

    /**
     * DOM
     */
    const createList = _createList();
    return (
        <div className={ style.main }>
            { createList }
        </div>
    )
}
